import { ReactNode } from "react";

interface DangerRowProps {
  title: string;
  description: string;
  buttonLabel: string;
  onAction: () => void;
  confirmation?: ReactNode;
}

export function DangerRow({
  title,
  description,
  buttonLabel,
  onAction,
}: DangerRowProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 py-4 border-b border-border last:border-b-0">
      <div className="max-w-md">
        <p className="text-[13px] font-medium text-foreground">{title}</p>
        <p className="text-[12px] text-muted-foreground mt-1">{description}</p>
      </div>
      <button
        type="button"
        onClick={onAction}
        className="self-start border border-destructive/60 text-destructive hover:bg-destructive/10 px-3 py-2 rounded-md text-[13px] font-medium transition-colors"
      >
        {buttonLabel}
      </button>
    </div>
  );
}
